import React from "react";
import { Col, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const submenuData = [
  {
    name: "Competitive Research",
    subMenu: [
      {
        name: "Domain Authority",
        desc: "Check DA and PA and track your domain age for Free",
        href: "/da-pa-checker",
      },
      {
        name: "SERP Simulator",
        desc: "Craft and test meta descriptions visually, instantly",
        href: "/serp-simulator",
      },
      {
        name: "Keyword Gap",
        desc: "Find Competitor’s  Ranking keywords and grow your traffic",
        href: "/keyword-gap",
      },
    ],
  },
  {
    name: "Page Seo",
    subMenu: [
      {
        name: "SEO Inspector",
        desc: "Audit Your Website Errors in Seconds",
        href: "/seo-Inspector",
      },
      {
        name: "On Pages Seo",
        desc: "One click to optimize your entire site’s SEO",
        href: "/on-page-seo-tool",
      },
      {
        name: "Structure Data",
        desc: "Turn content into rich snippets with structured data",
        href: "/structured-data",
      },
      {
        name: "Robots.txt",
        desc: "Generate a perfect Crawler control file quickly.",
        href: "/manage-robots-txt",
      },
    ],
  },
  {
    name: "Content Checker",
    subMenu: [
      {
        name: "Bix Content Generator",
        desc: "Generate Quality Content with SeoBix’s Bix Content Generator",
        href: "/bix-content-generator",
      },
      {
        name: "Quality Content Checker",
        desc: "Analyze the AI content & quality of the content ",
        href: "/content-quality-checker",
      },
      {
        name: "Humanizer",
        desc: "Humanize AI-generated content with Humanizer",
        href: "/bix-humanizer",
      },
    ],
  },
  {
    name: "Backlinks",
    subMenu: [
    
      {
        name: "Backlink Checker",
        desc: "Analyze the backlinks of your domains",
        href: "/backlink-checker",
      },
      {
        name: "Link Building Tool",
        desc: "Store Your Backlinks easily with SeoBix",
        href: "/link-building-tool",
      },
      {
        name: "Top Pages",
        desc: "Find the top domains linked to your website",
        href: "/top-pages",
      },
    ],
  },
  {
    name: "Keyword Research",
    subMenu: [
      {
        name: "Bix keyword Research",
        desc: "Find the best keywords for SEO success",
        href: "/best-keyword-research-tool",
      },
      {
        name: "Domain Ranking Keyword",
        desc: "Track keywords of your domain",
        href: "/bix-keyword-analyzer",
      },
      {
        name: "Keyword Builder",
        desc: "Store smart keyword ideas in seconds",
        href: "/construct-your-seo-success-with-keyword-builder",
      },
      {
        name: "Position Tracker",
        desc: "Track the rankings of the keywords you’re optimizing",
        href: "/keyword-position-tracker",
      },
    ],
  },
  {
    name: "Bix Lab With Google",
    subMenu: [
      {
        name: "Google Analytics",
        desc: "Integrated Google Analytics by connecting your domain.",
        href: "/google-analytics",
      },
      {
        name: "Google Search Console",
        desc: "Analyze your domain traffic by linking your domain. ",
        href: "/search-console",
      },
      {
        name: "Google Trends",
        desc: "Go with the trends and boost your traffic with SeoBix",
        href: "/trending-now-on-google",
      },
    ],
  },
];

const SideTab = () => {
  const currentPath = window.location.pathname;
  return (
    <div
      className="px-4 bg-light"
      style={{ minHeight: "100vh", borderRight: "1px solid #dee2e6" }}
    >
      {submenuData.map((section, index) => (
        <div key={index} className="mb-2">
          <Nav className="flex-column">
            {section.subMenu.map((item, idx) => {
              const isActive = currentPath === item.href;

              return (
                <a
                  key={idx}
                  href={item.href}
                  title={item.desc}
                  className={`nav-link px-3 py-2 mb-1 rounded ${
                    isActive
                      ? "bg-primary text-white fw-bold border-start border-4 border-white"
                      : "text-dark"
                  }`}
                  style={{
                    fontSize: "0.95rem",
                    transition: "background 0.2s ease",
                  }}
                >
                  {item.name}
                </a>
              );
            })}
          </Nav>
        </div>
      ))}
    </div>
  );
};

export default SideTab;
